import styled from 'styled-components';
import { Col, Typography } from 'antd';
import { BtnSuccess } from '../../styles/Buttons';

const { Text } = Typography;

export const Wrapper = styled(Col)`
  display: flex;
  flex-direction: column;
  height: 100%;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  color: #707070;
  padding: 10px 24px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

export const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const TextCustom = styled(Text)`
  font-size: ${props => props.size || 14}px;
  line-height: 22px;
  color: ${props => props.color || '#828282'};
  font-weight: ${props => (props.bold ? 'bold' : 'normal')};
`;

export const ButtomAction = styled(BtnSuccess)`
  font-weight: bold;
  margin-top: 22px !important;
  height: 50px;
  min-width: 140px;
`;
